import {
  SET
} from 'reducer/types/prefix'

// Base CONSTANT for ROUTE types
export const ROUTE = 'ROUTE'

export const SET_ROUTE = `${SET}${ROUTE}`